import axios from 'axios';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { FEEDBACK } from '../../../../../commons/api';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { Tag, Form, Modal, Input, DatePicker, Spin } from 'antd';
import localStorage from '../../../../../utils/localStorage';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const Line = (props) => {
  const getOption = () => {
    let theme = props.selectedThemeing;
    let option = {
      legend: {
        textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' },
        data: [
          {
            name: 'test1',
            icon: 'roundRect',
            textStyle: {}
          }
        ]
      },
      tooltip: {
        trigger: 'axis',
        textStyle: {}
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            name: props.graphprops.title,
            backgroundColor: theme === 'lightTheme' ? 'white' : 'black'
          }
        }
      },
      xAxis: {
        type: 'category',
        data: props.graphprops,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          backgroundColor: '#9a9191',
          textStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ]
    };
    return option;
  };

  const [option, setOption] = useState(getOption());
  const [loading, setLoading] = useState(false);
  const [TagNAme, setTagNAme] = useState('');
  const [DeviceCOde, setDeviceCOde] = useState('');
  const [visible, setVisible] = useState(false);
  const [Feedback, setFeedback] = useState('');
  const [currentName, setCurrentName] = useState('');
  const [currentValue, setCurrentValue] = useState('');
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const myRef = useRef(null);
  let timeTicket = useRef(null);
  let requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const handleOk = async (e) => {
    e.preventDefault();
    try {
      await myRef.current.validateFields();
      const siteId = localStorage.get('currentSite');
      const payload = {
        Feedback,
        CreatedTime: currentName,
        Value: currentValue,
        ParameterCode: TagNAme,
        DeviceCode: DeviceCOde,
        SiteId: siteId
      };

      const accessToken = localStorage.get('accessToken');
      const deviceTypeObject = {
        method: 'POST',
        url: `${FEEDBACK.INSERT}?SiteId=${siteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: payload
      };

      await axios(deviceTypeObject);
      setVisible(false);
      setFeedback('');
      myRef.current.resetFields();
      props.refereshData('close');
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    setVisible(false);
    setFeedback('');
  };

  const onChartClick = (cellData) => {
    let data = props.graphprops.currentDateData;
    data.forEach((item) => {
      let testing = item.Name;
      let delimiter = '$$$';
      const result = testing.split(delimiter);
      setTagNAme(result[0]);
      setDeviceCOde(result[1]);
    });

    if (cellData.seriesType === 'line') {
      let newObject = data.filter((predict) => {
        return predict.DateTime && cellData.name && cellData.seriesName === predict.Description;
      });
      if (newObject && Array.isArray(newObject)) {
        setVisible(true);
        // Convert UTC to IST when setting currentName
        setCurrentName(dayjs.utc(cellData.name, 'DD/MM/YYYY HH:mm:ss').tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss'));
        setCurrentValue(cellData.value);
      }
    }
  };

  const onFeedBack = (e) => {
    setFeedback(e.target.value);
    myRef.current.setFieldsValue('Feedback');
  };

  const getData = async (props) => {
    requestCheck.current = false;
    let theme = props.selectedThemeing;
    let json = [];
    setLoading(true);
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
      setLoading(false);
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
          setLoading(false);
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;

          setLoading(false);
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0) || (props.graphprops.enableMock && props.graphprops.enableMock !== true)) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      if (Array.isArray(json)) {
        let dates = [];
        let values = [];
        let name = '';
        let tagnames = [];
        let seriesarray = [];
        let legendsdata = [];
        json.forEach((val) => {
          if (val.Name !== name) {
            if (tagnames.indexOf(val.Name) === -1) {
              tagnames.push(val.Name);
              name = val.Name;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: theme === 'lightTheme' ? 'black' : 'white',
                  fontSize: 14,
                  fontWeight: 'bold'
                }
              });
            }
          }
        });

        let yAxisData = props && props.graphprops && props.graphprops[props.graphprops.graph] && props.graphprops[props.graphprops.graph].YAxis ? JSON.parse(props.graphprops[props.graphprops.graph].YAxis) : [];
        let yaxis = yAxisData && Array.isArray(yAxisData) && yAxisData.map((value, index) => {
          let axis = {};
          axis.splitLine = {
            show: true,
            lineStyle: {
              color: '#504c4c'
            }
          };
          axis.triggerEvent = true;
          axis.axisLine = {
            show: true,
            lineStyle: {
              color: props &&
                props.graphprops &&
                props.graphprops[props.graphprops.graph] &&
                props.graphprops[props.graphprops.graph].colors &&
                props.graphprops[props.graphprops.graph].colors[index] !== undefined
                ? value && value.tags && value.tags.length > 1
                  ? 'white'
                  : props &&
                  props.graphprops &&
                  props.graphprops[props.graphprops.graph] &&
                  props.graphprops[props.graphprops.graph].colors &&
                  props.graphprops[props.graphprops.graph].colors[index]
                : 'white'
            }
          };
          axis.max = value.max;
          axis.min = value.min;
          axis.offset = value.offset;
          axis.interval = value.interval;
          axis.position = value.position;
          axis.name = value.name;
          axis.tags = value.tags;
          return axis;
        });

        yaxis && yaxis.unshift({
          splitLine: {
            show: true,
            lineStyle: {
              color: '#504c4c'
            }
          },
          triggerEvent: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: props.graphprops && props.graphprops.line && props.graphprops.line.Linecolor && props.graphprops.line.Linecolor.length > 0 ? props.graphprops.line.Linecolor[0] : 'white'
            }
          },
          axisLabel: { fontSize: 15 },
          tags: []
        });

        tagnames.forEach((tagval, tagindex) => {
          values = [];
          json.forEach((jsonval) => {
            if (tagnames[0] === jsonval.Name && tagindex === 0) {
              let format =
                props.graphprops.line && props.graphprops.line.xAxisDateFormat
                  ? props.graphprops.line.xAxisDateFormat
                  : 'YYYY-MM-DD HH:mm:ss';

              let date = '';
              if (props.graphprops && props.graphprops.type === 'live') {
                // Convert UTC to IST when formatting dates
                date = dayjs
                  .utc(jsonval.DateTime)
                  .tz(props.currentTimeZone)
                  .format(format);

              } else {
                date = dayjs
                  .utc(jsonval.DateTime)
                  .tz(props.currentTimeZone)
                  .format(format);
              }

              dates.push(date);
            }
            if (tagval === jsonval.Name) {
              values.push(jsonval.Value);
            }

          });

          if (yaxis.length > 1) {
            yaxis.forEach((axis, axisindex) => {
              if (axis && axis.tags && axis.tags.indexOf(tagval) !== -1) {
                seriesarray.push({
                  name: legendsdata[tagindex]['name'],
                  data: values,
                  yAxisIndex: axisindex,
                  type: 'line',
                  markPoint: {
                    data:
                      props.graphprops &&
                        props.graphprops[props.graphprops.graph] &&
                        props.graphprops[props.graphprops.graph].minMax !== 'false'
                        ? [
                          { type: 'max', name: 'Max' },
                          { type: 'min', name: 'Min' }
                        ]
                        : null
                  }
                });
              }
            });
          } else {
            seriesarray.push({
              name: legendsdata[tagindex]['name'],
              data: values,
              type: 'line',
              markPoint: {
                data:
                  props.graphprops &&
                    props.graphprops[props.graphprops.graph] &&
                    props.graphprops[props.graphprops.graph].minMax !== 'false'
                    ? [
                      { type: 'max', name: 'Max' },
                      { type: 'min', name: 'Min' }
                    ]
                    : null
              }
            });
          }
        });

        const newOption = cloneDeep(getOption());
        if (props.graphprops && props.graphprops.line && props.graphprops.line.colors && props.graphprops.line.colors.length > 0) {
          newOption.color = props.graphprops.line.colors;
        }
        let series = await trendLabelTranslation(seriesarray, props.translationCache);
        newOption.xAxis.data = [...dates];
        newOption.yAxis = Array.isArray(yaxis) && Object.keys(yaxis).length > 0 && yaxis !== null
          ? yaxis && { ...yaxis } && yaxis
          : { ...yaxis } || {};
        newOption.series = [...series];
        newOption.legend = [...legendsdata];
        setOption(newOption);
      }
    }
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {dayjs().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss')}
        </Tag>
      ) : null}

      {errorInAPI || noDataInDB ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          {loading && <Spin tip="Loading..." />}
          <ReactEcharts
            option={option}
            onEvents={{ click: (cellData) => onChartClick(cellData) }}
            notMerge={true}
            lazyUpdate={true}
            style={{ height: '80%', width: '100%' }}
            className="react_for_echarts"
          />
        </span>
      )}
      <Modal
        open={visible}
        title="Feedback"
        width={1000}
        height={1000}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form {...{ labelCol: { span: 4 }, wrapperCol: { span: 10 } }} onFinish={handleOk} ref={myRef} name="form">
          <Form.Item label="Date">
            <DatePicker
              readOnly
              value={currentName ? dayjs(currentName).tz('Asia/Kolkata') : dayjs().tz('Asia/Kolkata')}
              style={{ width: '400px' }}
              showTime
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>
          <Form.Item label="Value">
            <Input value={currentValue || ''} readOnly />
          </Form.Item>
          <Form.Item label="TagName">
            <Input value={TagNAme || ''} readOnly />
          </Form.Item>
          <Form.Item label="DeviceCode">
            <Input value={DeviceCOde || ''} readOnly />
          </Form.Item>
          <Form.Item label="Feedback" onChange={onFeedBack}>
            <Input.TextArea value={Feedback} />
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(Line);

